import axios from "axios";
import { apiCall } from "./authServices";

// Fetch all course categories
export const fetchCourseCategories = async () => {
  try {
    const response = await apiCall({
      endpoint: "api/course-categories/get-course-category",
      method: "GET",
    });
    return response; // Return the categories array
  } catch (error) {
    console.error("Error fetching course categories:", error);
    throw error;
  }
};

export const fetchActiveCourseCategories = async () => {
  try {
    const response = await apiCall({
      endpoint: "api/course-categories/get-active-course-category",
      method: "GET",
    });
    return response; // Return the categories array
  } catch (error) {
    console.error("Error fetching course categories:", error);
    throw error;
  }
};

// Add a new course category
export const addCourseCategory = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/course-categories/add-course-category",
      method: "POST",
      payload,
    });
    return response; // Return the response for further use
  } catch (error) {
    console.error("Error adding course category:", error);
    throw error;
  }
};

// Update an existing course category
export const updateCourseCategory = async (id, payload) => {
  try {
    const response = await apiCall({
      endpoint: `api/course-categories/update-course-category/${id}`,
      method: "PUT",
      payload,
    });
    return response; // Return the response for further use
  } catch (error) {
    console.error("Error updating course category:", error);
    throw error;
  }
};

// Delete a course category
export const deleteCourseCategory = async (id) => {
  try {
    const response = await apiCall({
      endpoint: `api/course-categories/delete-course-category/${id}`,
      method: "DELETE",
    });
    return response; // Return the response for further use
  } catch (error) {
    console.error("Error deleting course category:", error);
    throw error;
  }
};

// Update the status of a course category using updateCourseCategory API
export const updateCourseStatus = async (id, status) => {
  try {
    // Reuse the existing updateCourseCategory API
    const response = await updateCourseCategory(id, { status }); // Pass only the status in the payload
    return response; // Return the response for further use
  } catch (error) {
    console.error("Error updating course status:", error);
    throw error;
  }
};

// create course
export const GetCourseData = async (payload) => {
  try {
    const endpoint = "api/courses/get-course";
    const response = await apiCall({
      endpoint: endpoint,
      method: "POST",
      payload: payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// create add course
export const AddNewCourse = async ({ payload }) => {
  try {
    const endpoint = "api/courses/create-course";
    const response = await apiCall({
      endpoint: endpoint,
      payload: payload,
      method: "POST",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

// course validation
export const CourseValidationCheck = async ({ payload }) => {
  try {
    const endpoint = "api/courses/add-course-validation";
    const response = await apiCall({
      endpoint: endpoint,
      method: "POST",
      payload: payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getModuleList = async (courseId) => {
  try {
    const endpoint = `api/course-modules/get-course-module-list/` + courseId;
    const response = await apiCall({
      endpoint: endpoint,
      method: "GET",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const publishCourse = async (courseId, payload) => {
  try {
    const endpoint = `api/courses/publish/` + courseId;
    const response = await apiCall({
      endpoint: endpoint,
      method: "POST",
      payload: payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDetailedCourseData = async (courseId) => {
  try {
    const endpoint = `api/courses/course-details-user-end/` + courseId;
    const response = await apiCall({
      endpoint: endpoint,
      method: "GET",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getM3U8LinkForCourse = async (payload) => {
  try {
    const endpoint = `api/courses/generate-video-presigned-url`;
    const response = await apiCall({
      endpoint: endpoint,
      method: "POST",
      payload: payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getViewCourses = async (payload, categoryId = 0) => {
  try {
    const endpoint = "api/courses/all-category-wise-courses/" + categoryId;
    const response = await apiCall({
      endpoint: endpoint,
      method: "POST",
      payload: payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const putToggleBookmark = async ({ payload, courseId }) => {
  try {
    const endpoint = `api/courses/save-or-unsave-course/` + courseId;
    const response = await apiCall({
      endpoint: endpoint,
      method: "PUT",
      payload: payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSavedCourses = async (payload) => {
  try {
    const endpoint = "api/courses/get-all-saved-courses";
    const response = await apiCall({
      endpoint: endpoint,
      method: "POST",
      payload: payload,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const ToggleCourseFeaturedAPI = async (courseId, payload) => {
  try{
      const endpoint = `api/courses/feature-course/${courseId}`
      const response = await apiCall({
        endpoint: endpoint,
        method: "PUT",
        payload: payload
      });
    return response;
  }catch (error){
    throw error;
  }
}
export const getIncompleteExams = async () => {
  try {
    const endpoint = `api/dashboard/get-incomplete-exams`;
    const response = await apiCall({
      endpoint: endpoint,
      method: "GET",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAdminSuggestions = async () => {
  try {
    const endpoint = `api/dashboard/get-admin-suggestions`;
    const response = await apiCall({
      endpoint: endpoint,
      method: "GET",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getFeaturedCourses = async () => {
  try {
    const endpoint = `api/dashboard/get-featured-courses`;
    const response = await apiCall({
      endpoint: endpoint,
      method: "GET",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCourseCategories = async () => {
  try {
    const endpoint = `api/dashboard/get-course-categories`;
    const response = await apiCall({
      endpoint: endpoint,
      method: "GET",
    });
    return response;
  } catch (error) {
    throw error;
  }
};
